import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { Label, Radio, Text } from '@iwoca/orion-ui';
import { FormattedMessage } from 'react-intl';

import { getLoanDurationInMonths } from '../../../../myOffers/MyOffers.helpers';

export const ChooseDuration = ({
    offers,
    selectedOffer,
    setSelectedOffer
}: {
    offers: TFormalOffer[];
    selectedOffer: TFormalOffer | null;
    setSelectedOffer: (offer: TFormalOffer | null) => void;
}) => {
    return (
        <div className="w-full space-y-m">
            <Text className="text-xl font-bold">
                <FormattedMessage
                    id="_.topup_choice.from_today_i_want_to_repay_over"
                    defaultMessage="From today, I want to repay over"
                />
            </Text>

            {offers.map((offer) => (
                <Radio.Frame key={offer.offer_id}>
                    <Radio
                        name="duration-choice"
                        id={`duration-${getLoanDurationInMonths(
                            offer.duration!
                        )}`}
                        onChange={() => setSelectedOffer(offer)}
                        checked={selectedOffer === offer}
                    />
                    <Label
                        htmlFor={`duration-${getLoanDurationInMonths(
                            offer.duration!
                        )}`}
                    >
                        <FormattedMessage
                            id="_.topup_choice.fresh_duration_choice"
                            defaultMessage="{duration} monthly repayments"
                            values={{
                                duration: getLoanDurationInMonths(
                                    offer.duration!
                                )
                            }}
                        />
                    </Label>
                </Radio.Frame>
            ))}
        </div>
    );
};
